import { Validators } from "@angular/forms";

const mainServerURL = 'https://viamarin.viashipyard.com/'; // 'http://vias.hat-san.com.tr/';
const serverURL = mainServerURL + 'vias/';
const printURL = serverURL;
const contractorServerURL = serverURL + 'viascontractor.php?';
const months = [
	{ label: 'Month', data: '0' },
	{ label: 'January', data: '1' },
	{ label: 'Febuary', data: '2' },
	{ label: 'March', data: '3' },
	{ label: 'April', data: '4' },
	{ label: 'May', data: '5' },
	{ label: 'June', data: '6' },
	{ label: 'July', data: '7' },
	{ label: 'August', data: '8' },
	{ label: 'September', data: '9' },
	{ label: 'October', data: '10' },
	{ label: 'November', data: '11' },
	{ label: 'December', data: '12' }
];
const productTypes = [
	{ label: 'material', data: '1' },
	{ label: 'equipment', data: '2' },
	{ label: 'service', data: '3' }
];
const accessTypes = [
	{ label: 'out', data: '0' },
	{ label: 'in', data: '1' }
];
const validations = {
	email: Validators.pattern('^([a-zA-Z0-9_\\-\\.]+)@([a-zA-Z0-9_\\-\\.]+)\\.([a-zA-Z]{2,5})$'),
	phone: Validators.pattern('(0[1-9]|[1-9])[0-9][0-9]([ \t]|[-]|)[1-9][0-9][0-9]([ \t]|[-]|)[0-9][0-9]([ \t]|[-]|)[0-9][0-9]'),
	decimal: Validators.pattern('^[0-9.,]+$'),//1.00,00
	numeric_001: Validators.pattern('^[0-9()]+$'),//01234~
	numeric_002: Validators.pattern('^[0-9.]+$'),//1.11.1
	numeric_003: Validators.pattern('^[0-9,]+$'),//1,11,1
	time_001: Validators.pattern('^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$'),//00:00-23:59
	max_100: Validators.compose([
		Validators.pattern('^(100|[1-9][0-9]?)$'), // 1-100 arası rakamları kabul eder
		Validators.min(1),
		Validators.max(100)
	]),
};
export { mainServerURL, serverURL, contractorServerURL, printURL, months, productTypes, validations, accessTypes };
